import {nl} from './nl'

export const es = {
	...nl,
	project_name: 'Broederlijk Delen',
	cards: {
		event: {
			linklabel: ''
		},
		page: {
			linklabel: ''
		},
		project: {
			linklabel: ''
		}
	},
	form: {
		file: {
			delete: '',
			invalid_type: '',
			too_large: ''
		},
		back: '',
		submit: ''
	},
	newsletter: {
		title: '',
		submitted: ''
	},
	search: {
		search: '',
		submit: '',
		empty: '',
		results: {
			loading: '',
			empty: ''
		}
	},
	error404: {
		title: 'Page not found',
		text: `The page you are looking for might have been removed, had its name 
			changed, or is temporarily unavailable.`,
		btnlabel: 'Back to home'
	},
	cookies: {
		banner: {
			text: 'This website uses cookies to improve your browsing experience.',
			settings: 'Cookie settings',
			accept: 'Accept all cookies',
			decline: 'Refuse optional cookies'
		},
		settings: {
			title: 'Cookie settings',
			text:
				'You can accept all cookies at once or adjust your preferences in the cookie settings.',
			save: 'Save',
			accept: 'Accept all cookies',
			decline: 'Refuse optional cookies'
		},
		used: 'Used cookies',
		table: {
			name: 'Name',
			purpose: 'Purpose',
			domain: 'Domain/host',
			duration: 'Duration'
		},
		duration: {
			persistent: 'Persistent',
			session: 'Session',
			day: 'day',
			days: 'days',
			month: 'month',
			months: 'months',
			year: 'year'
		}
	},
	webshop: {
		filter: {
			load_more: '',
			load_more_products: '',
			load_more_downloads: '',
			label: '',
			reset: '',
			empty: '',
			no_products: '',
			no_downloads: ''
		},
		header: {
			cart: {
				items_in_cart: '',
				empty: ''
			}
		},
		products: {
			card: {
				from: '',
				pieces: '',
				free: '',
				add: '',
				notifiy: '',
				remove: '',
				featured: '',
				last_pieces: '',
				temporarily_unavailable: '',
				sold_out: '',
				coming_soon: '',
				added: ''
			},
			notify: {
				info: '',
				newsletter: '',
				submit: '',
				submitted: ''
			},
			related: ''
		},
		cart: {
			title: '',
			from: '',
			pieces: '',
			remove: '',
			add: '',
			edit: '',
			edited: '',
			added: '',
			quantity_discount: '',
			free: '',
			empty: '',
			total: '',
			abandoned: {
				title: '',
				text: ``,
				btnclose: '',
				btnback: ''
			},
			order: ''
		}
	},
	campagne: {
		open: '',
		close: '',
		share: '',
		languages: '',
		hero: {
			help: ''
		},
		footer: {
			copyright: '',
			do_action: '',
			register_action: ''
		},
		action: {
			watch: '',
			share: '',
			watch_page: '',
			promotion_title: '',
			promotion_share: '',
			poster: '',
			need: '',
			download: '',
			order: '',
			share_online: '',
			header: '',
			shareimage: '',
			copied: ''
		},
		actions: {
			title: '',
			loadmore: '',
			no_results: '',
			clearfilters: ''
		},
		inspiration: {
			practical: ''
		},
		inspirations: {
			checkout: '',
			select: ''
		},
		info: {
			moreinfo: '',
			practical: '',
			on: '',
			from: '',
			until: '',
			at: '',
			between: '',
			and: '',
			box: '',
			not_public: '',
			public: '',
			sign_up: ''
		},
		register: {
			postal_code: '',
			school: '',
			multiple_days: '',
			end_hour: '',
			at: '',
			h: '',
			until: '',
			when: '',
			submit: '',
			textarea: '',
			textarea_placeholder: '',
			max100: '',
			organisation: '',
			location_placeholder: '',
			date_placeholder: '',
			hour_placeholder: ''
		},
		affichebuilder: {
			with: '',
			we_share: '',
			at: ''
		},
		contact: {
			name: '',
			email: '',
			question: '',
			submit: '',
			thanks: ''
		},
		filters: {
			location: '',
			keyword: '',
			periode: '',
			periode_detail: '',
			and: '',
			filtertitle: '',
			radius: ''
		},
		filterkeys: {
			food: '',
			sell: '',
			sports: '',
			culture: '',
			party: '',
			drinks: '',
			doortodoor: '',
			other: ''
		},
		error404: {
			title: '',
			text: ''
		},
		cookies: {
			text: '',
			accept: '',
			decline: ''
		}
	},
	news: {
		publishedOn: 'Publicado el'
	}
}
